module.exports = __webpack_public_path__ + "static/media/Face.6e46a37a.PNG";